import { setCookie } from 'utils/Cookies';

export default (function(){
	let _bar;
	let _submit;
	let _boxes;
	let selection = [];
	let isOpen = false;
	const removeButtons = '.js-compare-remove';
	const wrap = '.js-compare-wrap';
	const popup = '.js-popup';
	const close = '.js-compare-bar-close';
	const open = '.js-compare-bar-open';
	const counter = '.js-compare-bar-counter';
	const template = '.js-compare-template';

	function init(bar, boxes) {
		initCheckboxes(boxes);

		_bar = bar;
		_boxes = boxes;
		_submit = $('.js-compare-bar-submit');
		_submit.on('click', e => {
			e.preventDefault();
			const href = $(e.target).attr('href');
			const set = [...new Set(selection)].map(bike => bike.id);

			if (set.length > 0) {
				setCompareCookie(set);
				window.location.href = href;
			}
		});

		$(open).on('click', e => {
			e.preventDefault();
			isOpen = true;
			$(wrap).addClass('is-open');
			handleResize();
		});

		$(close).on('click', e => {
			e.preventDefault();
			closeBar();
		})
	}

	function closeBar() {
		isOpen = false;
		handleResize();
		$(wrap).removeClass('is-open');
	}

	function initCheckboxes(boxes) {
		boxes.on('change', e => {
			if (checkMax()) {
				return;
			}

			if (e.target.checked) {
				const productElement = $(e.target).closest('.js-single-product');
				const bike = {
					id: $(e.target).data('item'),
					title: $(e.target).data('title'),
					thumb: productElement.find('img').attr('src'),
					price: $(e.target).data('price'),
				}
				add(bike);
			} else {
				remove($(e.target).data('item'));
			}
		});
	}

	function add(bike) {
		createThumbnail(bike);
		selection.push(bike);
		toggleBar();
	}

	function createThumbnail(bike) {
		const newBike = $(template).clone().removeClass('js-compare-template');
		newBike.appendTo(_bar);
		newBike.find('.js-compare-price').text(bike.price);
		newBike.find('.js-compare-title').text(bike.title);
		newBike.find('.js-compare-thumb').attr('src', bike.thumb);
		newBike.find('.js-compare-remove').data('id', bike.id)
		bike.el = newBike.get(0);

		$(newBike).find(removeButtons).on('click', e => {
			e.preventDefault();
			const checkbox = $(_boxes).filter(`[data-item=${bike.id}]`);
			$(checkbox).prop( "checked", false );
			remove(bike.id);
		});
	}

	function remove(id) {
		const bike = selection.find(e => e.id == id);
		$(bike.el).remove();
		selection = selection.filter(e => e.id != id);
		toggleBar();
	}

	function toggleBar() {
		if (selection.length <= 0) {
			$('body').removeClass('compare-bar-open');
			$(wrap).addClass('is-empty');
		} else {
			$('body').addClass('compare-bar-open');
			$(wrap).removeClass('is-empty');
		}

		movePop();
		updateCounter();
	}

	function updateCounter() {
		$(counter).text(selection.length);
	}

	function movePop() {
		if (selection.length <= 0) {
			$(popup).css("transform","translateY(0)");
			$(window).off("resize.watchBar")
		} else {
			handleResize();
			$(window).on("resize.watchBar", handleResize);
		}
	}

	function handleResize() {
		const barHeight = $(wrap).outerHeight();
		$(popup).css("transform",`translateY(-${barHeight}px)`);
	}

	// Set Compare Cookie
	function setCompareCookie(ids) {
		setCookie('bike_comparer', JSON.stringify(ids), 100);
	}

	function checkMax() {
		const checkedAmount = $(_boxes).filter(':checked').length;

		if (checkedAmount >= 3) {
			const uncheckedBoxes = $(_boxes).filter(':not(:checked)');
			$(uncheckedBoxes).prop('disabled', true);
		} else {
			const disabledBoxes = $(_boxes).filter(':disabled');
			if ($(disabledBoxes).length > 0) {
				$(disabledBoxes).prop('disabled', false);
			}
		}
		return false;
	}

	return {
		init, initCheckboxes
	};
})();